import React, { useState, useContext, useEffect } from "react";
import { withStyles } from "@mui/styles";
import { Checkbox,
         FormControl,
         Grid,
         FormLabel,
         FormControlLabel,
         TextField,
         RadioGroup,
         Radio } from "@mui/material";
import { ErrorContext } from "services/Utils";


const CountsTagProperties = (props) => {
  const [errors, setErrors] = useState([]);
  const errorContext = useContext(ErrorContext);
  const { tagId, tagProperties, handleTagPropChange, readOnly } = props;
  const cvtChecked = tagProperties?.da?.counts;
  const readOnlyOrChecked = readOnly || cvtChecked;
    
  function togglePropDA() {
    const current = tagProperties?.da || {};
    delete current['counts'];
    handleTagPropChange(tagId, "da", cvtChecked ? current : {...current, counts: {}});
  }
    
  return (
    <div style={{ width: "100%" }}>
      <FormControl variant="standard" style={{ width: "100%", margin: 0, marginBottom: 0 }}>
        <FormLabel component="legend">
            Count type
        </FormLabel>
      </FormControl>
      <FormControl variant="standard" style={{ width: "100%" }}>
        <RadioGroup
          aria-label="countsType"
          name="countsType"
          value={tagProperties.countsType ?? ""}
            onChange={(event) => {
                const value = event.target.value;
                if(!value && tagProperties?.da) togglePropDA();
                handleTagPropChange(tagId, "countsType", event.target.value);
            }}
          row
          disabled={readOnlyOrChecked}
        >
          <FormControlLabel
            value=""
            control={<Radio />}
            label="Not a counter"
            disabled={readOnlyOrChecked}
          />
          <FormControlLabel
            value="sum"
            control={<Radio />}
            label="Sum"
            disabled={readOnlyOrChecked}
          />
          <FormControlLabel
            value="sample"
            control={<Radio />}
            label="Sample"
            disabled={readOnlyOrChecked}
          />
          <FormControlLabel
            value="diff"
            control={<Radio />}
            label="Difference"
            disabled={readOnlyOrChecked}
          />
        </RadioGroup>
      </FormControl>
      <Grid container spacing={3}>
          { tagProperties.countsType &&
            <Grid item>
                <FormControl variant="standard">
                    <TextField
                        variant="standard"
                        aria-label="label"
                        id="duration"
                        name="duration"
                        disabled={readOnlyOrChecked}                        
                        label="Duration (minutes)"
                        value={ tagProperties.counts?.duration || ""}
                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                        onChange={(event) => {
                            const counts = tagProperties.counts || {};
                            handleTagPropChange(tagId, "counts", {...counts, duration: event.target.value.replace(/[^0-9]/g, '')});
                        }}
                        required
                        style={{
                            margin: 6,
                        }} />
                </FormControl>
        { tagProperties.countsType &&
        <FormLabel component="legend">
              <Checkbox
                size="small" checked={ cvtChecked }
                onChange={(e) => { togglePropDA(); e.stopPropagation() } }
                onClick={(e) => { e.stopPropagation() } }
              />
              Calculated Value (CVT) for Count Tag enabled <i>(be sure you know what you are doing before enabling!)</i>
        </FormLabel>
        }
                
            </Grid>
          }
      </Grid>
    </div>
  );
};

export default CountsTagProperties;
